import s from './List.scss'
import MaterialTable from '@material-table/core'
import { timezoneDate } from 'utils/helpers'
import { FaClone } from 'react-icons/fa'

const columns = [
  { title: 'Name', field: 'name', defaultSort: 'asc' },
  {
    title: 'Created By',
    field: 'createdBy',
    render: row => row.createdBy?.fullName ?? ''
  },
  {
    title: 'Created On',
    field: 'createdAt',
    render: row => timezoneDate(row.createdAt, 'hh:mm A')
  },
  { title: 'Last Modified By', field: 'updatedBy', render: row => row.updatedBy?.fullName ?? '' },
  {
    title: 'Last Modified On',
    field: 'updatedAt',
    render: row => timezoneDate(row.updatedAt, 'hh:mm A')
  },
  {
    title: 'Visibility',
    field: 'visibility',
    render: row => row.visibility.toLowerCase()
  }
]

const List = ({ templates, deleteTemplate, openEditModal, cloneTemplate }) => {
  return (
    <div className={s.listWrapper}>
      <MaterialTable
        title="Current Checklists Templates:"
        columns={columns}
        data={templates}
        options={{
          actionsColumnIndex: -1,
          sorting: true,
          headerStyle: {
            backgroundColor: '#eee',
            color: '#000',
            position: 'sticky',
            top: 0,
            zIndex: 1,
            fontSize: '14px'
          },
          maxBodyHeight: '400px',
          pageSize: 20,
          padding: 'dense'
        }}
        style={{
          boxShadow: 'none',
          fontSize: '14px'
        }}
        actions={[
          () => ({
            icon: 'edit',
            tooltip: 'Edit Template',
            onClick: (event, rowData) => openEditModal(rowData)
          }),
          () => ({
            icon: () => <FaClone />,
            tooltip: 'Clone Template',
            onClick: (event, rowData) => cloneTemplate(rowData.id)
          }),
          () => ({
            icon: 'delete',
            tooltip: 'Delete Template',
            onClick: (event, rowData) => deleteTemplate(rowData.id),
            disabled: templates.length === 1
          })
        ]}
      />
    </div>
  )
}

export default List
